<!--
<input class="gui-input" type="text" formControlName="address" [value]="" name="address" required #addresstext style="padding: 12px 37px; border: 1px solid #ccc;" placeholder="Address: Cra 13 #72-19">
 -->

<mat-form-field class="example-full-width">
  <mat-label>Address</mat-label>
  <input matInput formControlName="address" [value]="" name="address" required #addresstext  placeholder="Address: Cra 13 #72-19">
</mat-form-field>
